import React from 'react'
import PropTypes from 'prop-types'

class Text extends React.Component {
  render() {
    const {text, modifier, 'data-testid': dataTestId} = this.props

    if (!text) {
      return null
    }

    let className = 'text'

    if (modifier) {
      className += ` text--${modifier}`
    }

    return (
      <div data-testid={dataTestId} className={className}>
        {text}
      </div>
    )
  }
}

Text.propTypes = {
  text: PropTypes.any,
  modifier: PropTypes.string,
  'data-testid': PropTypes.string,
}

export default Text
